import { paramValidatorError } from './errors';
export var urlValidatorError = paramValidatorError('url', "Url must be a string");
export var urlValidator = function (url) {
    var typeofUrl = typeof url;
    if (typeofUrl !== 'string') {
        return urlValidatorError;
    }
};
//# sourceMappingURL=url.js.map